var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form__group" }, [
    _c(
      "div",
      { staticClass: "dropzone-wrapper" },
      [
        _c(
          "vue-dropzone",
          {
            ref: "dropzone",
            class: { error: _vm.errors.first(this.name) },
            attrs: {
              id: "dropzone",
              options: _vm.dropzoneOptions,
              "include-styling": false,
              "destroy-dropzone": true,
              useCustomSlot: true,
            },
            on: {
              "vdropzone-file-added": _vm.onFileAdded,
              "vdropzone-sending": _vm.onSend,
              "vdropzone-success": _vm.onFileUploaded,
              "vdropzone-error": _vm.onFileError,
              "vdropzone-removed-file": _vm.onFileRemoved,
              "vdropzone-queue-complete": _vm.onComplete,
              "vdropzone-complete": _vm.onComplete,
              "vdropzone-processing": _vm.onProcessing,
            },
          },
          [
            !_vm.validFiles.length.length ||
            (_vm.validFiles.length.length && _vm.multiple)
              ? _c("div", { staticClass: "dropzone-custom-content" }, [
                  _c("span", { staticClass: "subtitle" }, [
                    _vm._v("Drag and drop your files here"),
                  ]),
                ])
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _vm.files.length
          ? _c(
              "div",
              { staticClass: "selected-files" },
              _vm._l(_vm.files, function (file, index) {
                return _c(
                  "div",
                  {
                    key: file.uuid,
                    staticClass: "selected",
                    class: {
                      "is-image": file.filetype.includes("image/"),
                      "is-valid": file && file.uuid && file.filename,
                    },
                  },
                  [
                    file && file.filetype.includes("image/")
                      ? _c("picture", { staticClass: "selected__image" }, [
                          _c("img", {
                            attrs: { src: file.url, alt: file.filename },
                          }),
                        ])
                      : _c("span", {
                          staticClass: "selected__filetype",
                          domProps: {
                            textContent: _vm._s(file.filetype.split("/")[1]),
                          },
                        }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(file.filename))]),
                    _vm._v(" "),
                    file && file.uuid && file.filename
                      ? _c(
                          "button",
                          {
                            staticClass: "selected__remove",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.removeFile(file)
                              },
                            },
                          },
                          [_c("SvgIcon", { attrs: { icon: "x" } })],
                          1
                        )
                      : _vm._e(),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c("label", { staticClass: "form__label" }, [_vm._v(_vm._s(_vm.label))]),
    _vm._v(" "),
    _c("div", { staticClass: "form__validation" }, [
      _vm._v(_vm._s(_vm.errors.first(this.name))),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }